module.exports = __webpack_public_path__ + "img/cartao.37779cb7.svg";